import { createFileRoute, notFound } from '@tanstack/react-router';

import { ConversationPage, prefetchConversation } from '@/features/conversations';

/** A conversation is addressed by its store, so the org-wide thread carries the store in the path. */
export const Route = createFileRoute('/_authed/_active/org/inbox/$storeId/$conversationId')({
  beforeLoad: ({ context, params }) => {
    if (!context.me.stores.some((store) => store.id === params.storeId)) throw notFound();
  },
  loader: async ({ context, params }) => ({
    crumb: await prefetchConversation(context.queryClient, params.storeId, params.conversationId),
  }),
  component: ConversationPage,
});
